import { useState, useCallback } from 'react';
import { searchService, SearchRequest, SearchResult, SearchDocument } from '../services/searchService';

export const useSearch = () => {
  const [results, setResults] = useState<SearchDocument[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [metadata, setMetadata] = useState<any>(null);

  const search = useCallback(async (params: SearchRequest) => {
    try {
      setIsLoading(true);
      setError(null);
      const searchResult = await searchService.semanticSearch(params);
      setResults(searchResult.results || []);
      setMetadata({
        query: searchResult.query,
        totalResults: searchResult.totalResults,
        executedAt: searchResult.executedAt,
        searchType: searchResult.searchType,
        filters: searchResult.filters
      });
    } catch (err) {
      setError('Erro ao realizar a busca. Tente novamente.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const getSuggestions = useCallback(async (query: string) => {
    if (query.length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      const suggestions = await searchService.getSuggestions(query);
      setSuggestions(suggestions);
    } catch (err) {
      console.error('Erro ao obter sugestões:', err);
    }
  }, []);

  return {
    results,
    isLoading,
    error,
    suggestions,
    metadata,
    search,
    getSuggestions,
  };
}; 